export default __webpack_public_path__ + "static/media/checklist.dcbfc1cd.svg";